export default function COUNTIFS() {
  return (
    <div className="p-4">
      <h1>COUNTIFS</h1>
    </div>
  );
}
